import React from "react";

const MixmaxIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2785_810)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.00390625 35.8347H7.92894V4.15106H0.00390625V35.8347Z",
  fill: "#E55CFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.0369 4.15106L0.00390625 35.8347H7.92894L23.9619 4.15106H16.0371H16.0369Z",
  fill: "#24235C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.0371 35.8348H23.9621V4.15112H16.0371V35.8348Z",
  fill: "#E55CFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.0707 4.15131L16.0374 35.835H23.9622L39.9955 4.15131H32.0707Z",
  fill: "#24235C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.0256 35.8348H39.9507V4.15112H32.0256V35.8348Z",
  fill: "#E55CFF"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2785_810"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 31.6849,
  fill: "white",
  transform: "translate(0 4.15002)"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(MixmaxIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;